import {Helmet} from "react-helmet";
import {useNavigate} from "react-router";
import Constants from "../Constants";

const SinglePostShow = ({postItemShow, mainUser, postShowSet, categoryIdSetter}) => {
    const navigator = useNavigate();

    const deletePostAction = async (postIdToDelete) => {
        let delAns = (await deletePost(postIdToDelete));
        if (delAns.state === "success") {
            alert("پست حذف شد. ".concat(delAns.message));
        } else {
            alert("متاسفانه پست حذف نشد. ".concat(delAns.message))
        }
        categoryIdSetter([postItemShow.category_id, postItemShow.sub_cat_id]);
        navigator("/posts_list");
    }

    const deletePost = async (id) => {
        let appendUrl = "delete_post/".concat(id)
        let url = Constants.BaseUrl.concat(appendUrl);
        const deleteRes = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '.concat(mainUser.token),
            },
        });
        return await deleteRes.json();
    }


    return (
        <div className="container m-5 p-2">

            <Helmet>
                <meta charSet="utf-8"/>
                <title>{postItemShow.blog_title}</title>
                {/*<link rel="canonical" href="http://mysite.com/example"/>*/}

                <meta name="description" content={postItemShow.blog_summery}/>
                <meta name="keywords" content={postItemShow.blog_key_words}/>
                <meta name="author" content={postItemShow.blog_author}/>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>

                {/*     <meta name="og:title" content="__META_OG_TITLE__"/>
                <meta name="og:description" content="__META_OG_DESCRIPTION__"/>
                <meta name="og:image" content="__META_OG_IMAGE__"/>*/}
            </Helmet>

            {(mainUser.userMode === "admin") &&
            <div className="text-start">

                <button onClick={(e) => {
                    e.preventDefault();
                    postShowSet(postItemShow);
                    navigator("/edit_post");

                }
                } className="btn btn-primary btn-lg text-light fw-bolder">ویرایش
                    پست
                </button>
                <button id="delete_post_btn"
                        onClick={(e) => {
                            e.preventDefault();
                            /*confirmAlert({
                                title: 'حذف پست',
                                message: 'شما در حال حذف این پست هستید. آیا میخواهید این پست حذف شود؟',
                                 /!*   <ul>
                                    <li style={{color: 'red'}}>شما در حال حذف این پست هستید. آیا میخواهید این پست حذف شود؟</li>
                               {/!*     <li style={{color: 'green'}}>Total successful records are {successCount} and Total
                                        failure records are {errorCount}.
                                    </li>
                                    <li style={{color: 'green'}}>Please verify data under Recent Uploads tab.</li>*!/}
                                </ul>,*!/
                                buttons: [
                                    {
                                        label: 'حذف شود',
                                        color: 'red',
                                    },
                                    {
                                        label: 'انصراف',
                                        color:'green',
                                    },
                                ]
                            })*/


                            let confRes = window.confirm("شما در حال حذف این پست هستید. آیا میخواهید این پست حذف شود؟")
                            // console.log(confRes);
                            confRes && deletePostAction(postItemShow.id);
                        }
                        }
                        className="btn btn-danger text-light text-center mx-3 fw-bolder {{$post->id}}">
                    حذف پست
                </button>

            </div>
            }
            <div className="row text-center align-items-stretch">
                <div className="col-md-12 g-2 align-items-stretch">
                    <div className="card bg-light border-warning my-5">
                        <img id="post_img_cover" className="card-img-top h-75" src={postItemShow.blog_index_image}
                             alt=""/>
                        <div className="card-body justify-content-center">
                            <h3 className="text-center text-dark fw-bolder mb-3">{postItemShow.blog_title}</h3>
                            <div className="m-4 p-3" dangerouslySetInnerHTML={{__html: postItemShow.blog_body}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SinglePostShow;